module.exports = __webpack_public_path__ + "static/media/person-pushing-svgrepo-com.a15299d1.svg";